module.exports = __webpack_public_path__ + "static/S-Class 4-c32d9de5d6ee6fdab5146daad8293939.jpg";